import { Injectable } from '@angular/core';

interface ClientPortalSession {
  clients: { id: number; name: string }[];
  contactName: string;
  token: string;
  selectedClientId: number;
  multiClientMode: boolean;
}

@Injectable({ providedIn: 'root' })
export class ClientPortalService {
  private readonly KEY = 'clientPortalSession';

  getSession(): ClientPortalSession | null {
    const raw = sessionStorage.getItem(this.KEY);
    return raw ? JSON.parse(raw) : null;
  }

  setSession(
    clients: { id: number; name: string }[],
    contactName: string,
    token: string,
    selectedClientId: number,
    multiClientMode: boolean
  ): void {
    sessionStorage.setItem(this.KEY, JSON.stringify({ clients, contactName, token, selectedClientId, multiClientMode }));
  }

  clearSession(): void {
    sessionStorage.removeItem(this.KEY);
  }

  isLoggedInAs(clientId: number): boolean {
    const s = this.getSession();
    return s !== null && s.clients.some(c => c.id === clientId);
  }

  setSelectedClient(clientId: number): void {
    const s = this.getSession();
    if (s) {
      s.selectedClientId = clientId;
      sessionStorage.setItem(this.KEY, JSON.stringify(s));
    }
  }

  getToken(): string | null {
    return this.getSession()?.token ?? null;
  }
}
